/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-22 16:17:49
 * @Explain: 语言配置
 */
export default {
  'COMMON.LANG.ar': '阿拉伯语',
  'COMMON.LANG.de': '德语',
  'COMMON.LANG.en': '英语',
  'COMMON.LANG.en-GB': '英语 (英国)',
  'COMMON.LANG.en-US': '英语 (美国)',
  'COMMON.LANG.es': '西班牙语',
  'COMMON.LANG.es-MX': '西班牙语 (墨西哥)',
  'COMMON.LANG.fr': '法语',
  'COMMON.LANG.id': '印尼语',
  'COMMON.LANG.it': '意大利语',
  'COMMON.LANG.ja': '日语',
  'COMMON.LANG.ko': '韩语',
  'COMMON.LANG.ms': '马来语',
  'COMMON.LANG.pl': '波兰语',
  'COMMON.LANG.pt': '葡萄牙语',
  'COMMON.LANG.pt-BR': '葡萄牙语 (巴西)',
  'COMMON.LANG.ru': '俄语',
  'COMMON.LANG.th': '泰语',
  'COMMON.LANG.tr': '土耳其语',
  'COMMON.LANG.vi': '越南语',
  'COMMON.LANG.zh-Hans': '中文 (简体)',
  // 原：中文(繁体)，改：中文(港繁)，原因：后端清洗数据问题
  'COMMON.LANG.zh-Hant': '中文 (港繁)',
  'COMMON.LANG.zh-CN': '中文',
  'COMMON.LANG.zh-HK': '中文 (港繁)',
  'COMMON.LANG.zh-TW': '中文 (台繁)',
  'COMMON.LANG.cs': '捷克语',
  'COMMON.LANG.fi': '芬兰语',
  'COMMON.LANG.fil-PH': '菲律宾语',
  'COMMON.LANG.hi': '印地语',
  'COMMON.LANG.nl': '荷兰语',
  'COMMON.LANG.ur': '乌尔都语',
  'COMMON.LANG.uz': '乌兹别克语',
  'COMMON.LANG.un-Know': '未知语言',
};
